import React from "react";
import { useLanguage } from "../../../hooks/useLanguage";
import styles from "./Ci.module.css";

const colors = ["#00CFA9", "#00BDC7", "#159FDF", "#3264E8", "#0789C8", "#00AEA2"];
const rgb = (hex: string) => [1, 3, 5].map((offset) => parseInt(hex.slice(offset, offset + 2), 16)).join(" / ");
const CiColor = () => {
  const { isKr } = useLanguage();
  return (
    <section className={styles.meaning}>
      <div className={styles.section}>
        <p className={styles.eyebrow}>BRAND COLOURS</p>
        <h2 className={styles.title}>{isKr ? "여섯 면의 색, 하나의 인상" : "Six colours, one identity"}</h2>
        <p className={styles.copy}>{isKr ? "심볼은 민트에서 블루로 이어지는 여섯 가지 색으로 구성됩니다. 각 면에는 그라데이션 없이 하나의 단색을 사용하고, 워드마크에는 짙은 네이비를 적용합니다. 아래 색상은 심볼의 왼쪽 위부터 시계 방향 순서입니다." : "The symbol uses six colours ranging from mint to blue. Each face has one solid colour, with no gradient, while the wordmark uses a deep navy. The colours below follow the symbol clockwise from the upper left."}</p>
        <div className={styles.colors}>{colors.map((hex, index) => <div key={hex}><div className={styles.swatch} style={{ backgroundColor: hex }} /><p className={styles.colorName}>{isKr ? `모듈 ${index + 1}` : `Module ${index + 1}`}</p><p className={styles.colorCode}>{hex}<br />RGB {rgb(hex)}</p></div>)}</div>
        <div className={styles.navy}><div className={styles.swatch} style={{ backgroundColor: "#111B2E" }} /><div><p className={styles.colorName}>{isKr ? "워드마크 · 네이비" : "Wordmark · Navy"}</p><p className={styles.colorCode}>#111B2E<br />RGB 17 / 27 / 46</p></div></div>
      </div>
    </section>
  );
};
export default CiColor;
